<template>
    <div class="pickup-points-input">
        <ErrorsZone class="col-6" v-if="validationErrors" :errors="validationErrors"></ErrorsZone>
        <div class="mb-2">
            <ul v-if="items.length" class="list-group">
                <li v-for="item in items" :key="item.uuid" class="list-group-item">
                    <button type="button" class="btn btn-danger float-right" @click="removeItem(item)">
                        <i class="fad fa-times"></i> Retirer
                    </button>
                    {{ item.name }}
                </li>
            </ul>
            <div v-else class="alert alert-info">
                <i class="fad fa-info-circle"></i> Aucun
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <div class="input-group">
                        <input class="form-control" type="text" id="newItemText" v-model.trim="newItemText" @keydown.enter.prevent="addItemFromNewItemForm">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" @click="addItemFromNewItemForm">
                                <i class="fad fa-plus"></i> Ajouter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" :name="name" :value="JSON.stringify(items)">
        <ErrorsZone class="col-6" v-if="dynamicValidationError" :errors="dynamicValidationError"></ErrorsZone>
    </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import ErrorsZone from "../ErrorsZone";

export default {
    name: "PickupPointsInput",

    components: {
        ErrorsZone,
    },

    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Array,
            required: false,
            default: [],
        },
        validationErrors: {
            type: Object,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            newItemText: '',
            dynamicValidationError: null,
            lValidationErrors: this.validationErrors,
            items: this.value || [],
        };
    },

    methods: {
        addItemFromNewItemForm() {
            this.dynamicValidationError = null;

            if (this.newItemText.trim() === '') {
                return;
            }

            this.addItem({
                name: this.newItemText,
            });
            this.newItemText = '';
        },

        addItem(data) {
            this.items.push({
                uuid: uuidv4(),
                name: data.name,
            });
        },

        removeItem(itemToRemove) {
            this.items = this.items.filter(i => i.uuid !== itemToRemove.uuid);
        },
    },
}
</script>
